/* Winkelwagen: de drawer van UpCart is de enige winkelwagen.
 *
 * Twee dingen:
 *   1. /cart bestaat niet meer als pagina. Een klik op een winkelwagenlink opent de drawer,
 *      en wie er tóch rechtstreeks belandt (bladwijzer, oude link, terugknop) wordt
 *      teruggestuurd naar de vorige pagina met de drawer open.
 *   2. Stond de drawer open toen de pagina herlaadde, dan gaat hij daarna weer open.
 *
 * Waarom een vlag in sessionStorage en niet in de URL: de drawer moet ook terugkomen na een
 * herlaadactie die wij niet zelf veroorzaken (een app die de pagina ververst, de terugknop),
 * en sessionStorage overleeft dat wel en verdwijnt vanzelf als het tabblad dichtgaat.
 *
 * Dit hoort in het thema en niet in de custom CSS of de HTML-velden van UpCart: het gaat over
 * links in het thema en het moet draaien vóór UpCart geladen is.
 */
(function () {
  var VLAG = 'dgm_cart_open';

  function lees() { try { return sessionStorage.getItem(VLAG); } catch (e) { return null; } }
  function zet(v) { try { v ? sessionStorage.setItem(VLAG, '1') : sessionStorage.removeItem(VLAG); } catch (e) {} }

  function isCartPad(pad) { return pad.replace(/\/+$/, '') === '/cart'; }

  /* UpCart laadt asynchroon. Openen kan dus mislukken op het moment dat wij het willen;
     daarom kort blijven proberen en na tien seconden opgeven in plaats van eeuwig door te
     tikken. */
  function openDrawer() {
    if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
    return false;
  }
  function openDrawerZodraHetKan() {
    if (openDrawer()) return;
    var t = setInterval(function () { if (openDrawer()) clearInterval(t); }, 100);
    setTimeout(function () { clearInterval(t); }, 10000);
  }

  /* 1a. Rechtstreeks op /cart beland: markeer en ga terug. De referrer alleen gebruiken als
         die van deze winkel is en zelf niet /cart is -- anders blijf je heen en weer kaatsen. */
  if (isCartPad(location.pathname)) {
    zet(true);
    var terug = '/';
    if (document.referrer) {
      try {
        var u = new URL(document.referrer);
        if (u.origin === location.origin && !isCartPad(u.pathname)) terug = u.href;
      } catch (e) {}
    }
    location.replace(terug);
    return;
  }

  /* 1b. Klikken op een winkelwagenlink: drawer openen in plaats van navigeren. In de
         capture-fase, zodat het thema er niet eerst zelf iets mee doet. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !isCartPad(u.pathname)) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawerZodraHetKan();
  }, true);

  /* 2. Open/dicht onthouden. UpCart levert hier eigen abonnementen voor; die bestaan pas als
        de app geladen is, dus even wachten tot ze er zijn. */
  (function abonneer(pogingen) {
    if (typeof window.upcartSubscribeCartOpened === 'function' &&
        typeof window.upcartSubscribeCartClosed === 'function') {
      window.upcartSubscribeCartOpened(function () { zet(true); });
      window.upcartSubscribeCartClosed(function () { zet(false); });
      return;
    }
    if (pogingen > 0) setTimeout(function () { abonneer(pogingen - 1); }, 100);
  })(100);

  if (lees() === '1') openDrawerZodraHetKan();
})();
